// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import chevronUpIcon from "@/assets/icons/chevron-up.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ChevronUpIconProps = Omit<IconProps, "name">;

export function ChevronUpIcon(props: ChevronUpIconProps): React.ReactNode {
  return <Icon name={chevronUpIcon} {...props} />;
}
